module.exports = __webpack_public_path__ + "img/四川天府新区第七幼儿园.01cb2d74.jpg";